import Footer from 'components/Footer';
import Head from 'next/head';
import React, { CSSProperties } from 'react';
import ClubQuickLinks from '../Dashboard/ClubQuickLinks';
import { NavbarPages } from '../ui/Navbar/NavbarPages';

interface Props {
    content?: React.JSX.Element | React.JSX.Element[] | string | null;
    children?: React.JSX.Element | React.JSX.Element[] | string | null;
    title?: string;
    metaDescription?: string;
    head?: React.JSX.Element;
    style?: CSSProperties;
}

const Layout = ({ content = null, children, title, metaDescription, head, style }: Props) => {
    return (
        <>
            {head || (
                <Head>
                    {title && <title>{title}</title>}
                    {metaDescription && <meta name="description" content={metaDescription} />}
                </Head>
            )}

            <div style={style}>
                <NavbarPages />
                <div style={{ marginTop: '1rem' }}>{content || children}</div>
                <Footer />
            </div>
            <ClubQuickLinks />
        </>
    );
};

export default Layout;
